var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_vba") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "10.457 11.092 16.014 13.839 16.014 18.307 10.457 15.382 10.457 11.092",
    style: {
      fill: "#6483c0"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2,18.613l-5.926-3.12V10.8L16.2,13.724ZM10.642,15.27,15.83,18V13.953l-5.188-2.564Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "16.371 13.839 16.371 18.307 21.315 15.814 21.315 11.354 16.371 13.839",
    style: {
      fill: "#6483c0"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.186,18.607V13.725l5.313-2.67v4.873Zm.369-4.655v4.055L21.13,15.7V11.653Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "10.703 10.797 16.186 13.58 21.082 11.064 15.777 8.389 10.703 10.797",
    style: {
      fill: "#6483c0"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.187,13.788l-5.9-3,5.5-2.608,5.709,2.879ZM11.122,10.8l5.064,2.57,4.49-2.308-4.9-2.471Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "18.957 15.829 24.515 18.575 24.515 23.043 18.957 20.118 18.957 15.829",
    style: {
      fill: "#952781"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7,23.349l-5.926-3.12v-4.7L24.7,18.46Zm-5.557-3.343,5.188,2.731V18.689l-5.188-2.564Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "24.871 18.575 24.871 23.043 29.815 20.55 29.815 16.09 24.871 18.575",
    style: {
      fill: "#952781"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.687,23.343V18.461L30,15.791v4.873Zm.369-4.655v4.055l4.575-2.308V16.389Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "19.203 15.546 24.687 18.329 29.583 15.812 24.364 13.346 19.203 15.546",
    style: {
      fill: "#952781"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.687,18.536l-5.92-3.005,5.6-2.387L30,15.805ZM19.64,15.56l5.046,2.561,4.479-2.3-4.806-2.27Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "2.19 15.496 7.748 18.243 7.748 22.711 2.19 19.786 2.19 15.496",
    style: {
      fill: "#d87b30"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.932,23.017,2.006,19.9V15.2l5.926,2.929ZM2.375,19.674l5.188,2.731V18.357L2.375,15.793Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "8.104 18.243 8.104 22.711 13.048 20.218 13.048 15.758 8.104 18.243",
    style: {
      fill: "#d87b30"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92,23.011V18.129l5.313-2.67v4.873Zm.369-4.655v4.055L12.864,20.1V16.057Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "2.436 15.213 7.92 17.997 12.816 15.48 7.597 13.014 2.436 15.213",
    style: {
      fill: "#d87b30"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92,18.2,2,15.2l5.6-2.387,5.632,2.661ZM2.873,15.228l5.046,2.561,4.479-2.3-4.806-2.27Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "10.875 16.296 16.432 19.042 16.432 23.511 10.875 20.585 10.875 16.296",
    style: {
      fill: "#e0d400"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.617,23.816,10.691,20.7V16l5.926,2.929ZM11.06,20.474l5.188,2.731V19.157L11.06,16.593Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "16.789 19.042 16.789 23.511 21.733 21.017 21.733 16.557 16.789 19.042",
    style: {
      fill: "#e0d400"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6,23.811V18.929l5.313-2.67v4.873Zm.369-4.655v4.055L21.549,20.9V16.857Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "11.121 16.001 16.605 18.784 21.501 16.267 16.196 13.593 11.121 16.001",
    style: {
      fill: "#e0d400"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.605,18.991l-5.9-3,5.5-2.608,5.709,2.879ZM11.54,16.006l5.064,2.57,4.49-2.308-4.9-2.471Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVba);
export default __webpack_public_path__ + "static/media/vba.3eaa9c2fb7961c124239b3d1751d82a4.svg";
export { ForwardRef as ReactComponent };